import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'

Vue.use(Vuex)

const store = new Vuex.Store({
  getters: {
    username() {
      if (!Vue.$auth.check() || !Vue.$auth.user()) {
        return ''
      }

      return Vue.i18n.locale() === 'zh-Hant'
        ? Vue.$auth.user().name
        : Vue.$auth.user().english_name
    },
    empCode() {
      if (!Vue.$auth.check() || !Vue.$auth.user()) {
        return null
      }

      return Vue.$auth.user().emp_code
    },
    isAdmin() {
      if (!Vue.$auth.check() || !Vue.$auth.user()) {
        return ''
      }

      return Vue.$auth.user().is_admin
    },
    isAccountant() {
      if (!Vue.$auth.check() || !Vue.$auth.user()) {
        return ''
      }

      if (Vue.$auth.user().is_admin) {
        return true
      } else {
        const groups = Vue.$auth.user().permission_groups.map(e => e.id)
        return groups.includes(4)
      }
    },
    isSalesSupervisor() {
      if (!Vue.$auth.check() || !Vue.$auth.user()) {
        return ''
      }

      return Vue.$auth.user().is_sales_supervisor
    },
    canAssignOrder: () => order => {
      if (!Vue.$auth.check() || !Vue.$auth.user()) {
        return false
      }

      const user = Vue.$auth.user()

      if (user.is_admin) {
        return true
      } else {
        return (
          user.can_assign_order && user.area_code_perm.includes(order.area_code)
        )
      }
    },
    canAssignDemandOrder: () => order => {
      if (!Vue.$auth.check() || !Vue.$auth.user()) {
        return false
      }

      const user = Vue.$auth.user()

      if (user.is_admin) {
        return true
      } else {
        return order.superior_code === user.emp_code
      }
    },
    canProcessOrder: () => order => {
      if (!Vue.$auth.check() || !Vue.$auth.user()) {
        return false
      }

      const user = Vue.$auth.user()

      //羅淑玲00641 與 柯思羽00640 可互相處理對方的網單
      if (
        (user.emp_code === '00641' && order.sales_code === '00640') ||
        (user.emp_code === '00640' && order.sales_code === '00641')
      ) {
        return true
      }

      if (user.is_admin) {
        return true
      } else {
        return order.sales_code === user.emp_code
      }
    }
  },
  state: {},
  mutations: {},
  actions: {},

  modules: {
    app
  }
})

Vue.store = store

export default store
